module.exports = __webpack_public_path__ + "img/finger_lakes_culinary.ddd5d42c.jpg";